import {
  formatDateOnlyWithShortMonth,
  parseDateOnly,
  type DateOnlyString,
} from "../../utils/dateOnly";

export interface ManualTebraDateParams {
  readonly startDate?: DateOnlyString;
  readonly endDate?: DateOnlyString;
}

export function normalizeManualTebraPickerDate(
  value: unknown
): DateOnlyString | null {
  if (value === null || value === undefined || value === "") return null;
  if (!(value instanceof Date)) return parseDateOnly(value) ?? null;
  if (Number.isNaN(value.getTime())) return null;
  return (
    parseDateOnly(
      `${padYear(value.getFullYear())}-${padTwoDigits(
        value.getMonth() + 1
      )}-${padTwoDigits(value.getDate())}`
    ) ?? null
  );
}

export function buildManualTebraDateParams(
  startDate: DateOnlyString | null,
  endDate: DateOnlyString | null
): ManualTebraDateParams {
  if (startDate && endDate && startDate > endDate) {
    throw new Error("Signed from must not be after signed through");
  }
  return {
    startDate: startDate ?? undefined,
    endDate: endDate ?? undefined,
  };
}

export function formatManualTebraCalendarDate(
  value: string | null | undefined
): string {
  if (!value) return "—";
  const dateOnly = parseDateOnly(value);
  return dateOnly ? formatDateOnlyWithShortMonth(dateOnly) : value;
}

function padTwoDigits(value: number): string {
  return String(value).padStart(2, "0");
}

function padYear(value: number): string {
  return String(value).padStart(4, "0");
}
